import React, { Component } from "react";
import { Container, Form, Button, Nav, NavItem, NavLink } from "reactstrap";
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sample } from "lodash";
import { faClock } from "@fortawesome/free-solid-svg-icons";
library.add(faClock);

class Randomtest17 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 20
    };
  }
  render() {
    const { count } = this.state;
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">
                5. ข้อใดเป็นลักษณะเด่นของอาณาจักรล้านนา
              </h3>{" "}
              <br></br>
              <Button className="rdTest1" href="/conclude19_2">
                <h5>ก. นับถือพระพุทธศาสนานิกายเถรวาท</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude19_2">
                <h5>ข. ก่อตั้งราชธานีในพื้นที่ราบลุ่มแม่น้ำ</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude20_3">
                <h5>ค. มีวัฒนธรรมด้านต่าง ๆ ที่เป็นเอกลักษณ์</h5>
              </Button>
            </Form>

            <Button className="rdTestbt1" href="/conclude19_2">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberB">1</h3>
            <h3 className="ranknumberB1">2</h3>
            <h3 className="ranknumberB1">3</h3>
            <h3 className="ranknumberB1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/conclude19_2");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest17;
